import BlockType118Component from '@headlines/components/block/111-120/BlockType118.vue';
import { AdminBlockType } from '@headlines/types/block/adminBlockType';
import AdminBlockTypeAttributes from '@headlines/config/block/shared/attributes/AdminBlockTypeAttributes';

const AdminBlockType118: AdminBlockType = {
  component: BlockType118Component,
  attributes: AdminBlockTypeAttributes({}),
  articlesCount: 0,
};

export default AdminBlockType118;
